import { clsx } from 'clsx';
import { PropsWithChildren } from 'react';
import Text from '~/components/typographies/Text';
import styles from './Summary.module.scss';

interface TextAmountProps extends PropsWithChildren {
  error?: boolean;
  tabularNums?: boolean;
  className?: string;
}

export const Row = ({ children }: PropsWithChildren) => {
  return <div className={styles.row}>{children}</div>;
};

export const RowContainer = ({ children }: PropsWithChildren) => {
  return <div className={styles.rowContainer}>{children}</div>;
};

export const TotalRow = ({ children }: PropsWithChildren) => {
  return <div className={styles.totalRow}>{children}</div>;
};

export const TextTotalLabel = ({ children }: PropsWithChildren) => {
  return (
    <Text variant="subtitle2" className={clsx(styles.label, styles.total)}>
      {children}
    </Text>
  );
};

export const TextTotalAmount = ({ children, error }: PropsWithChildren & { error?: boolean }) => {
  return (
    <Text variant="subtitle2" className={clsx(styles.amount, styles.total, { [styles.error!]: error })} align="right">
      {children}
    </Text>
  );
};

export const TextLabel = ({
  children,
  error,
  className,
}: PropsWithChildren & { error?: boolean; className?: string }) => {
  return (
    <Text variant="body1" weight="regular" className={clsx(styles.label, className, { [styles.error!]: error })}>
      {children}
    </Text>
  );
};

export const TextAmount = ({ children, error, tabularNums = true, className }: TextAmountProps) => {
  return (
    <Text
      variant="body1"
      weight="regular"
      className={clsx(styles.amount, className, { [styles.error!]: error })}
      tabularNums={tabularNums}
      align="right"
    >
      {children}
    </Text>
  );
};

export const TextTaxableDetailLabel = ({
  children,
  error,
  className,
}: PropsWithChildren & { error?: boolean; className?: string }) => {
  return (
    <Text
      variant="caption"
      weight="medium"
      className={clsx(styles.label, className, { [styles.error!]: error })}
      tabularNums
    >
      {children}
    </Text>
  );
};

export const TextTaxableDetailAmount = ({ children, error, tabularNums = true, className }: TextAmountProps) => {
  return (
    <Text
      align="right"
      variant="caption"
      weight="medium"
      className={clsx(styles.amount, className, { [styles.error!]: error })}
      tabularNums={tabularNums}
    >
      {children}
    </Text>
  );
};
